import { TFunction } from 'react-i18next'
import * as Yup from 'yup'

export const groupValidationSchema = (t: TFunction) =>
  Yup.object({
    name: Yup.string().required(t('errorMessage.required')).max(255, t('errorMessage.shouldNotExceed255')),
    description: Yup.string().max(1000, t('errorMessage.shouldNotExceedCharacterLimit', { limit: 1000 }))
  })
